
"use strict";
import {http} from '../../core';
const RequestService = http.create();

export default {
    docSearch (params) {
        return RequestService.post("doc/search", params)
    },
    docList (params) {
        return RequestService.get("doc/list", params)
    }
}